import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductAddToCartListDialogComponent } from './product-add-to-cart-list-dialog.component';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    ProductAddToCartListDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    ProductAddToCartListDialogComponent,
  ]
})
export class ProductAddToCartListDialogModule { }
